import Box from '@redbubble/design-system/src/Box';
import Input from '@redbubble/design-system/src/Form/Input';
import Text from '@redbubble/design-system/src/Text';
import styles from './Filters.module.scss';
import { useFiltersContext } from './FiltersContext';
import { ExperienceValueType, OptimisticOption, OptionType } from './types';

export const FilterOptionInput = ({
  variant,
  option,
  optimisticOption,
  isOptimisticGroup,
}: {
  variant: ExperienceValueType;
  option: OptionType;
  optimisticOption?: OptimisticOption;
  isOptimisticGroup?: boolean;
}) => {
  const { handleOptionClick } = useFiltersContext();

  const checked = (() => {
    if (variant === 'radio') {
      if (isOptimisticGroup && optimisticOption) {
        return (
          optimisticOption.name === option.name && optimisticOption.checked
        );
      }
      return option.applied;
    }
    if (optimisticOption?.name === option.name) {
      return optimisticOption.checked;
    }
    return option.applied;
  })();

  return (
    <Box
      display="flex"
      alignItems="center"
      marginBottom="s"
      onClick={() =>
        !option.disabled && handleOptionClick(option.url, option.name, !checked)
      }
      className={[styles.inputWrapper, option.disabled && styles.disabled]
        .filter(Boolean)
        .join(' ')}
    >
      <Input
        key={`${option.name}_${option.label}`}
        type={variant}
        label={option.label}
        checked={checked}
        disabled={option.disabled}
        data-testid={`filter-option-${option.name}`}
      />
      <Text marginLeft="s">{option.label}</Text>
    </Box>
  );
};
